<template>
  <el-dialog
    :title="type === 'add' ? '新增' : '编辑'"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1200px"
    v-dialogDrag
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      inline
      label-width="150px"
      size="small"
    >
      <el-form-item label="设备厂商" prop="protocolTypeName">
        <el-select :disabled="true" v-model="ruleForm.protocolTypeName" placeholder="请选择">
        </el-select>
      </el-form-item>
      <el-form-item label="模板名称" prop="modelName">
        <el-select :disabled="true" v-model="ruleForm.modelName" placeholder="请选择"> </el-select>
      </el-form-item>
      <el-form-item label="实例" prop="pIid">
        <el-select :disabled="type === 'edit'" v-model="ruleForm.pIid" placeholder="请选择">
          <el-option
            v-for="item in instanceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备编码" prop="code">
        <el-input v-model="ruleForm.code" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备名称" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="areaCode">
        <el-select v-model="ruleForm.areaCode" placeholder="请选择" clearable>
          <el-option
            v-for="item in aeraList"
            :key="item.pr_code"
            :label="item.pr_name"
            :value="item.pr_code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="第三方标识" prop="externalId">
        <el-input v-model="ruleForm.externalId" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <el-form :model="tableData" ref="tableData" inline label-width="150px" size="small">
      <el-form-item
        v-for="(item, index) in tableData.domains"
        :key="item.id"
        :label="item.label"
        :prop="'domains.' + index + '.value'"
        :rules="item.required ? { required: true, message: '请输入', trigger: 'blur' } : null"
      >
        <el-input
          v-if="item.fieldType === 'string'"
          v-model="item.value"
          placeholder="请输入"
          clearable
        ></el-input>
        <el-input-number
          v-if="
            item.fieldType === 'int' || item.fieldType === 'float' || item.fieldType === 'double'
          "
          :min="0"
          :step="1"
          v-model="item.value"
          placeholder="请输入"
          clearable
        ></el-input-number>
        <el-switch
          v-if="item.fieldType === 'bool'"
          v-model="item.value"
          active-value="true"
          inactive-value="false"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
        <el-date-picker
          v-if="item.fieldType === 'datetime'"
          ref="datepicker"
          v-model="item.value"
          type="datetime"
          placeholder="选择日期时间"
          size="mini"
          :clearable="false"
          :editable="false"
          :prefix-icon="'el-icon-caret-bottom'"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="confirm" :loading="saveLoading"
        >保存</el-button
      >
      <el-button @click="dialogShow = false" size="small">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { IOTDeviceProtocolInstanceApi, IOTDeviceApi } from '@wiz-api/iot-device-management'
import devaspService from '@/services/pageService/devasp'
import { get } from 'lodash'

const iOTDeviceApi = new IOTDeviceApi()
const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
export default {
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
    editTitleInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    editBodyInfo: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      ruleForm: {
        protocolTypeName: '',
        modelName: '',
        code: '',
        name: '',
        pIid: '', // 实例id
        id: '', // 设备本身id，新增不需要传
        tid: '', // 模板id
        areaCode: '', // 区域code
        externalId: '', // 第三方标识
      },
      rules: {
        protocolTypeName: [{ required: true, message: '请输入', trigger: 'blur' }],
        modelName: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        pIid: [{ required: true, message: '请输入', trigger: 'blur' }],
        externalId: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      saveLoading: false,
      tableData: {},
      tableRules: {},
      instanceList: [], // 实例list
      aeraList: [], // 区域list
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    preventCallAreaInterface() {
      return get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management-tongre"].config')
        ?.preventCallAreaInterface
    },
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate(async (validRuleForm) => {
        if (validRuleForm) {
          this.$refs.tableData.validate(async (validTable) => {
            if (validTable) {
              const obj = {
                tid: this.ruleForm.tid,
                name: this.ruleForm.name,
                code: this.ruleForm.code,
                pIid: this.ruleForm.pIid,
                areaCode: this.ruleForm.areaCode,
                fieldValues: [],
                externalId: this.ruleForm.externalId,
              }
              if (this.type === 'add') {
                this.tableData.domains.forEach((item) => {
                  let value = null
                  if (item.fieldType === 'datetime') {
                    value = this.dayjs(item.value).format('YYYY-MM-DD HH:mm:ss')
                  } else {
                    value = item.value.toString()
                  }
                  obj.fieldValues.push({
                    tFid: item.id,
                    value,
                  })
                })
                const [err, res] = await iOTDeviceApi.create({
                  body: obj,
                })
                if (!err) {
                  this.$message.success('新增成功')
                  this.dialogShow = false
                  this.$emit('reload')
                }
              } else {
                obj.id = this.ruleForm.id
                this.tableData.domains.forEach((item) => {
                  let value = null
                  if (item.fieldType === 'datetime') {
                    value = this.dayjs(item.value).format('YYYY-MM-DD HH:mm:ss')
                  } else {
                    value = item.value.toString()
                  }
                  obj.fieldValues.push({
                    did: this.ruleForm.id,
                    tFid: item.id,
                    value,
                    id: item.did,
                  })
                })
                const [err, res] = await iOTDeviceApi.update(this.ruleForm.id, {
                  body: obj,
                })
                if (!err) {
                  this.$message.success('编辑成功')
                  this.dialogShow = false
                  this.$emit('reload')
                }
              }
            }
          })
        }
      })
    },
    // 获取实例类型
    async getInstance() {
      const [err, res] = await iOTDeviceProtocolInstanceApi.getList({
        protocolCode: this.editTitleInfo.protocolTypeCode,
        skipCount: 0,
        maxResultCount: 99,
      })
      if (!err) {
        this.instanceList = res.items
      }
    },
    async formTableData() {
      // ruleform
      this.ruleForm = {
        protocolTypeName: this.editTitleInfo.protocolTypeName,
        modelName: this.editTitleInfo.name,
        code: '',
        name: '',
        pIid: '', // 实例id
        tid: this.editTitleInfo.id, // 模板id
        id: '', // 设备的id
        areaCode: '',
        externalId: '',
      }
      const tableData = {
        domains: [],
      }
      // tabledata
      this.editBodyInfo.forEach((item) => {
        tableData.domains.push({
          label: item.fieldTitle,
          value: '',
          ...item,
        })
      })
      this.tableData = tableData
    },
    async formEditData() {
      // ruleform
      this.ruleForm.code = this.detailRow.code
      this.ruleForm.name = this.detailRow.name
      this.ruleForm.pIid = this.detailRow.pIid // 实例id
      this.ruleForm.id = this.detailRow.id // 设备的id
      this.ruleForm.areaCode = this.detailRow.areaCode // 区域code
      this.ruleForm.externalId = this.detailRow.externalId // 第三方标识

      // tabledata form
      const tempMap = {}
      this.detailRow.fieldValues.forEach((item) => {
        tempMap[item.fieldName] = {
          fieldId: item.fieldId,
          value: item.fieldValue,
          did: item.id,
        }
      })
      this.tableData.domains.forEach((item) => {
        if (tempMap[item.prop]) {
          const mapItem = tempMap[item.prop]
          item.value = mapItem.value
          item.fieldId = mapItem.fieldId
          item.did = mapItem.did
        }
      })
    },
    async getAera() {
      const [err, res] = await devaspService.getAera({
        token: 'portal_js',
      })
      if (!err) {
        this.aeraList = this.unflatten(res.data.items)
      }
    },
    unflatten(data, rootId = null, dataKey = 'pr_code', parentKey = 'pr_preentcode') {
      const tree = []
      const childrenMap = {}
      for (let i = 0; i < data.length; i += 1) {
        const item = { ...data[i] }
        const id = item[dataKey]
        const parentId = item[parentKey]

        if (Array.isArray(item.children)) {
          childrenMap[id] = item.children.concat(childrenMap[id] || [])
        } else if (!childrenMap[id]) {
          childrenMap[id] = []
        }
        item.children = childrenMap[id]

        if (parentId !== undefined && parentId !== rootId && parentId) {
          if (!childrenMap[parentId]) childrenMap[parentId] = []
          childrenMap[parentId].push(item)
        } else {
          tree.push(item)
        }
      }
      const treeList = []
      tree.forEach((firstClass) => {
        treeList.push({
          pr_code: firstClass.pr_code,
          pr_name: firstClass.pr_name,
        })
        if (firstClass.children && firstClass.children.length) {
          firstClass.children.forEach((secondClass) => {
            treeList.push({
              pr_code: secondClass.pr_code,
              pr_name: `--${secondClass.pr_name}`,
            })
            if (secondClass.children && secondClass.children.length) {
              secondClass.children.forEach((thirdClass) => {
                treeList.push({
                  pr_code: thirdClass.pr_code,
                  pr_name: `----${thirdClass.pr_name}`,
                })
              })
            }
          })
        }
      })
      return treeList
    },
  },
  async created() {
    await this.formTableData()
    if (this.type === 'edit') {
      await this.formEditData()
    }
    await this.getInstance()
    if (!this.preventCallAreaInterface) {
      await this.getAera()
    }
  },
}
</script>

<style lang="scss" scoped></style>
